module.exports = __webpack_public_path__ + "static/media/BEHAVIOR.a9e3e45d.svg";